import { parser } from 'react-native-markdown-display';

// Reuse the AST (including its stable node keys) when native rows remount.
// Rendering still uses the current rules/styles, so themes and actions update.
const recent = new Map();
let characters = 0;
const MAX_ENTRIES = 24;
const MAX_CHARACTERS = 256000;

function stableKeys(nodes, parent = 'markdown') {
  nodes.forEach((node, index) => {
    node.key = `${parent}/${node.type}:${index}`;
    stableKeys(node.children || [], node.key);
  });
}

export function nativeMarkdownAST(source, markdownIt, retain = true) {
  const cached = recent.get(source);
  if (cached?.markdownIt === markdownIt) {
    recent.delete(source);
    recent.set(source, cached);
    return cached.ast;
  }
  const ast = parser(source, value => value, markdownIt);
  // The library assigns random keys on each parse. Structural keys keep the
  // same native views alive when streaming appends text to an existing block.
  stableKeys(ast);
  if (retain) retainNativeMarkdownAST(source, markdownIt, ast);
  return ast;
}

export function retainNativeMarkdownAST(source, markdownIt, ast) {
  if (source.length <= MAX_CHARACTERS) {
    if (recent.has(source)) { recent.delete(source); characters -= source.length; }
    recent.set(source, { markdownIt, ast });
    characters += source.length;
    while (recent.size > MAX_ENTRIES || characters > MAX_CHARACTERS) {
      const oldest = recent.keys().next().value;
      characters -= oldest.length;
      recent.delete(oldest);
    }
  }
}
